export interface Comic {
  id: number;
  title: string;
  author: string;
  category: string;
  categorySlug: string;
  cover: string;
  description: string;
  rating: number;
  views: number;
  status: string;
  updatedAt: string;
  chapters: Chapter[];
  tags: string[];
}

export interface Chapter {
  id: number;
  title: string;
  updatedAt: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
}

export const categories: Category[] = [
  { name: '全部', slug: 'all', icon: 'ri-apps-line' },
  { name: '恋爱', slug: 'romance', icon: 'ri-heart-line' },
  { name: '奇幻', slug: 'fantasy', icon: 'ri-magic-line' },
  { name: '动作', slug: 'action', icon: 'ri-fire-line' },
  { name: '悬疑', slug: 'mystery', icon: 'ri-search-eye-line' },
  { name: '搞笑', slug: 'comedy', icon: 'ri-emotion-laugh-line' },
  { name: '剧情', slug: 'drama', icon: 'ri-film-line' },
  { name: '恐怖', slug: 'horror', icon: 'ri-ghost-line' },
  { name: '日常', slug: 'slice-of-life', icon: 'ri-sun-line' },
  { name: 'BL', slug: 'bl', icon: 'ri-user-heart-line' },
];

export const comics: Comic[] = [
  {
    id: 1,
    title: '再婚的皇后',
    author: 'Alpha Tart',
    category: '恋爱',
    categorySlug: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20romance%20genre%2C%20elegant%20empress%20in%20traditional%20royal%20dress%2C%20soft%20pastel%20color%20palette%2C%20clean%20white%20background%2C%20digital%20illustration%2C%20manga%20panel%20style&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '被丈夫背叛的皇后，在命运的十字路口选择了再婚。然而新的婚姻背后隐藏着更大的秘密，她能否找到真正的幸福？这是一部融合了宫廷斗争与浪漫爱情的史诗级作品。',
    rating: 9.7,
    views: 12500000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 101, title: '第101话 - 新的开始', updatedAt: '2026-08-03' },
      { id: 100, title: '第100话 - 决断的时刻', updatedAt: '2026-07-27' },
      { id: 99, title: '第99话 - 秘密的代价', updatedAt: '2026-07-20' },
      { id: 98, title: '第98话 - 阴谋浮现', updatedAt: '2026-07-13' },
      { id: 97, title: '第97话 - 王座之争', updatedAt: '2026-07-06' },
      { id: 96, title: '第96话 - 暗中较量', updatedAt: '2026-06-29' },
      { id: 95, title: '第95话 - 危机四伏', updatedAt: '2026-06-22' },
    ],
    tags: ['宫廷', '恋爱', '复仇', '正剧'],
  },
  {
    id: 2,
    title: '我独自升级',
    author: 'Chugong / DUBU',
    category: '动作',
    categorySlug: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20action%20genre%2C%20powerful%20male%20hunter%20with%20dark%20aura%2C%20monsters%20in%20background%2C%20dramatic%20lighting%2C%20cool%20color%20tones%2C%20clean%20composition%2C%20digital%20illustration&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '被称为"人类最弱兵器"的成镇宇，在一次濒死经历中获得了神秘系统的力量。从此他开始了不断升级变强的旅程，成为人类对抗魔物入侵的最后希望。',
    rating: 9.9,
    views: 50000000,
    status: '已完结',
    updatedAt: '2026-07-15',
    chapters: [
      { id: 200, title: '第200话 - 终章：新的开始', updatedAt: '2026-07-15' },
      { id: 199, title: '第199话 - 最终决战', updatedAt: '2026-07-08' },
      { id: 198, title: '第198话 - 王的对决', updatedAt: '2026-07-01' },
      { id: 197, title: '第197话 - 觉醒的力量', updatedAt: '2026-06-24' },
      { id: 196, title: '第196话 - 最后的守护者', updatedAt: '2026-06-17' },
      { id: 195, title: '第195话 - 世界之门', updatedAt: '2026-06-10' },
      { id: 194, title: '第194话 - 影之军团', updatedAt: '2026-06-03' },
    ],
    tags: ['系统', '升级', '战斗', '奇幻', '热血'],
  },
  {
    id: 3,
    title: '某天成为公主',
    author: 'Plutus / Spoon',
    category: '奇幻',
    categorySlug: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20fantasy%20genre%2C%20beautiful%20princess%20with%20golden%20hair%20in%20royal%20palace%2C%20sparkling%20magic%20effects%2C%20soft%20warm%20lighting%2C%20fairy%20tale%20atmosphere%2C%20clean%20composition&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '穿越成小说中的悲情公主，为了避免悲惨的命运结局，她决定用可爱与智慧赢得父皇的宠爱。然而事情的发展远比她预想的要复杂得多。',
    rating: 9.6,
    views: 18000000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 145, title: '第145话 - 父女之间', updatedAt: '2026-08-02' },
      { id: 144, title: '第144话 - 舞会之夜', updatedAt: '2026-07-26' },
      { id: 143, title: '第143话 - 隐藏的感情', updatedAt: '2026-07-19' },
      { id: 142, title: '第142话 - 姐姐的归来', updatedAt: '2026-07-12' },
      { id: 141, title: '第141话 - 帝国的使者', updatedAt: '2026-07-05' },
    ],
    tags: ['穿越', '父女', '宫廷', '治愈'],
  },
  {
    id: 4,
    title: '全知读者视角',
    author: 'Sing Shong / Sleepy-C',
    category: '剧情',
    categorySlug: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20drama%20genre%2C%20male%20protagonist%20with%20glasses%20reading%20a%20book%2C%20apocalyptic%20background%2C%20dramatic%20composition%2C%20warm%20amber%20lighting%2C%20clean%20digital%20illustration&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '金独子是唯一读完那部长达3149话的末日小说的人。当小说世界化为现实，他凭借对剧情的了如指掌，开始了在这个残酷世界中的求生之旅。',
    rating: 9.8,
    views: 32000000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 230, title: '第230话 - 神话之战', updatedAt: '2026-08-04' },
      { id: 229, title: '第229话 - 星座的意志', updatedAt: '2026-07-28' },
      { id: 228, title: '第228话 - 新世界', updatedAt: '2026-07-21' },
      { id: 227, title: '第227话 - 同伴的力量', updatedAt: '2026-07-14' },
    ],
    tags: ['末世', '系统', '剧情', '智斗'],
  },
  {
    id: 5,
    title: '她的私生活',
    author: 'Kim Sung-yeon',
    category: '恋爱',
    categorySlug: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20romance%20genre%2C%20modern%20office%20woman%20with%20secret%20hobby%2C%20warm%20sunset%20lighting%2C%20cityscape%20background%2C%20chic%20fashion%20style%2C%20clean%20digital%20illustration&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '白天是完美干练的美术馆策展人，晚上是狂热的偶像追星族。当成德美遇到了新的上司莱恩·戈尔德，她的双重生活开始面临前所未有的挑战。',
    rating: 9.5,
    views: 9800000,
    status: '已完结',
    updatedAt: '2026-06-20',
    chapters: [
      { id: 120, title: '第120话 - 最终话：我们', updatedAt: '2026-06-20' },
      { id: 119, title: '第119话 - 告白', updatedAt: '2026-06-13' },
      { id: 118, title: '第118话 - 迷宫的尽头', updatedAt: '2026-06-06' },
    ],
    tags: ['职场', '恋爱', '喜剧', '现代'],
  },
  {
    id: 6,
    title: '僵尸校园',
    author: 'Joo Dong-geun',
    category: '恐怖',
    categorySlug: 'horror',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20horror%20genre%2C%20students%20trapped%20in%20school%20during%20zombie%20outbreak%2C%20dark%20atmosphere%2C%20dramatic%20shadows%2C%20survival%20theme%2C%20intense%20composition%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '一所普通的高中突然爆发了僵尸病毒。被困在校园内的学生们，必须在资源有限、危机四伏的情况下团结一致，寻找逃出生天的方法。',
    rating: 9.4,
    views: 15000000,
    status: '已完结',
    updatedAt: '2026-05-30',
    chapters: [
      { id: 130, title: '第130话 - 最后的幸存者', updatedAt: '2026-05-30' },
      { id: 129, title: '第129话 - 绝望中的希望', updatedAt: '2026-05-23' },
      { id: 128, title: '第128话 - 突围行动', updatedAt: '2026-05-16' },
    ],
    tags: ['僵尸', '生存', '校园', '惊悚'],
  },
  {
    id: 7,
    title: '拥抱浪漫',
    author: 'Lee Hye-rin',
    category: '搞笑',
    categorySlug: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20comedy%20romance%20genre%2C%20couple%20laughing%20together%2C%20bright%20cheerful%20colors%2C%20spring%20cherry%20blossom%20background%2C%20light%20hearted%20mood%2C%20clean%20cute%20illustration&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '两个性格完全相反的人因为一次意外开始了同居生活。从互看不顺眼到渐渐萌生感情，这是一部让人笑中带泪的浪漫喜剧。',
    rating: 9.3,
    views: 7200000,
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 85, title: '第85话 - 心跳加速', updatedAt: '2026-08-01' },
      { id: 84, title: '第84话 - 意外的约会', updatedAt: '2026-07-25' },
      { id: 83, title: '第83话 - 家庭访问', updatedAt: '2026-07-18' },
    ],
    tags: ['同居', '欢喜冤家', '喜剧', '甜宠'],
  },
  {
    id: 8,
    title: '深海疑云',
    author: 'Park Min-ji',
    category: '悬疑',
    categorySlug: 'mystery',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20mystery%20thriller%20genre%2C%20detective%20in%20dark%20alley%2C%20rainy%20night%20atmosphere%2C%20deep%20blue%20color%20palette%2C%20suspicious%20shadow%2C%20noir%20style%2C%20clean%20composition&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '一个平静的海滨小镇接连发生离奇失踪事件。刑警韩智宇在调查过程中，逐渐揭开了隐藏在深海之下的惊人秘密。',
    rating: 9.2,
    views: 5600000,
    status: '连载中',
    updatedAt: '2026-08-03',
    chapters: [
      { id: 55, title: '第55话 - 深海之下', updatedAt: '2026-08-03' },
      { id: 54, title: '第54话 - 目击者', updatedAt: '2026-07-27' },
      { id: 53, title: '第53话 - 消失的痕迹', updatedAt: '2026-07-20' },
    ],
    tags: ['悬疑', '推理', '犯罪', '惊悚'],
  },
  {
    id: 9,
    title: '咖啡店的日常',
    author: 'Yoon Soo-ah',
    category: '日常',
    categorySlug: 'slice-of-life',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20slice%20of%20life%20genre%2C%20cozy%20coffee%20shop%20interior%2C%20warm%20morning%20light%2C%20barista%20making%20coffee%2C%20relaxing%20atmosphere%2C%20soft%20beige%20tones%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '在首尔一条安静的小巷里，有一家名为"温馨"的咖啡店。每天都有不同的顾客来到这里，分享着各自平凡而温暖的故事。',
    rating: 9.1,
    views: 4500000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 72, title: '第72话 - 雨天来客', updatedAt: '2026-08-04' },
      { id: 71, title: '第71话 - 老顾客的秘密', updatedAt: '2026-07-28' },
      { id: 70, title: '第70话 - 新员工', updatedAt: '2026-07-21' },
    ],
    tags: ['治愈', '日常', '美食', '温情'],
  },
  {
    id: 10,
    title: '剑之王',
    author: 'Kim Tae-hyung',
    category: '动作',
    categorySlug: 'action',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20action%20martial%20arts%20genre%2C%20swordsman%20in%20traditional%20hanbok%2C%20epic%20battle%20stance%2C%20dramatic%20wind%20effects%2C%20ancient%20Korean%20setting%2C%20clean%20powerful%20composition&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '在剑术衰落的时代，少年白一树怀揣着成为天下第一剑客的梦想。历经千辛万苦的修炼与无数生死决斗，他最终能否登上剑术之巅？',
    rating: 9.5,
    views: 11000000,
    status: '连载中',
    updatedAt: '2026-08-02',
    chapters: [
      { id: 160, title: '第160话 - 天下第一剑', updatedAt: '2026-08-02' },
      { id: 159, title: '第159话 - 宿命的对决', updatedAt: '2026-07-26' },
      { id: 158, title: '第158话 - 剑道巅峰', updatedAt: '2026-07-19' },
    ],
    tags: ['武侠', '成长', '战斗', '热血'],
  },
  {
    id: 11,
    title: '秘密关系',
    author: 'Jung Soo-jin',
    category: 'BL',
    categorySlug: 'bl',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20BL%20romance%20genre%2C%20two%20men%20standing%20close%20in%20office%20setting%2C%20subtle%20tension%2C%20warm%20evening%20light%2C%20professional%20attire%2C%20clean%20elegant%20illustration&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '在同一家公司工作的两人，因为一次意外事件开始了一段秘密关系。在职场与感情之间寻找平衡，他们的故事充满了甜蜜与心酸。',
    rating: 9.4,
    views: 8300000,
    status: '连载中',
    updatedAt: '2026-08-01',
    chapters: [
      { id: 95, title: '第95话 - 无法隐藏', updatedAt: '2026-08-01' },
      { id: 94, title: '第94话 - 出差之夜', updatedAt: '2026-07-25' },
      { id: 93, title: '第93话 - 危机', updatedAt: '2026-07-18' },
    ],
    tags: ['职场', 'BL', '秘密恋爱', '现代'],
  },
  {
    id: 12,
    title: '魔法学院特优生',
    author: 'Choi Eun-ji',
    category: '奇幻',
    categorySlug: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20cover%20art%20style%2C%20fantasy%20genre%2C%20female%20student%20casting%20magic%20in%20academy%20setting%2C%20magical%20sparkles%2C%20mystical%20library%20background%2C%20warm%20golden%20light%2C%20clean%20illustration&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '出身平民的艾琳凭借天赋考入王国最顶尖的魔法学院。在这个贵族子弟云集的地方，她将用自己的实力证明一切。',
    rating: 9.3,
    views: 6800000,
    status: '连载中',
    updatedAt: '2026-08-04',
    chapters: [
      { id: 78, title: '第78话 - 最终考试', updatedAt: '2026-08-04' },
      { id: 77, title: '第77话 - 禁术之谜', updatedAt: '2026-07-28' },
      { id: 76, title: '第76话 - 实战演练', updatedAt: '2026-07-21' },
    ],
    tags: ['魔法', '学院', '成长', '女性主角'],
  },
];

export const banners = [
  {
    id: 1,
    title: '我独自升级',
    subtitle: '2026年度最佳动作漫画 · 全网50亿点击',
    comicId: 2,
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20art%2C%20epic%20action%20scene%2C%20powerful%20hunter%20with%20glowing%20blue%20aura%2C%20shadow%20army%20behind%20him%2C%20dramatic%20perspective%2C%20dark%20atmosphere%20with%20golden%20highlights%2C%20cinematic%20composition&width=1400&height=600&seq=banner-01&orientation=landscape',
  },
  {
    id: 2,
    title: '全知读者视角',
    subtitle: '超人气末世智斗漫画 · 全网32亿点击',
    comicId: 4,
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20art%2C%20apocalyptic%20cityscape%2C%20male%20protagonist%20holding%20glowing%20book%2C%20constellations%20in%20night%20sky%2C%20dramatic%20epic%20composition%2C%20cool%20blue%20and%20gold%20color%20scheme&width=1400&height=600&seq=banner-02&orientation=landscape',
  },
  {
    id: 3,
    title: '再婚的皇后',
    subtitle: '宫廷浪漫史诗 · 全网12.5亿点击',
    comicId: 1,
    image: 'https://readdy.ai/api/search-image?query=Korean%20manhwa%20webtoon%20banner%20art%2C%20elegant%20empress%20in%20magnificent%20palace%20throne%20room%2C%20golden%20sunlight%20streaming%20through%20windows%2C%20romantic%20dramatic%20atmosphere%2C%20soft%20pastel%20warm%20tones&width=1400&height=600&seq=banner-03&orientation=landscape',
  },
];

export const faqs = [
  {
    question: '韩漫网的漫画都是免费的吗？',
    answer: '是的，韩漫网提供的所有韩国漫画均完全免费在线阅读。我们致力于为漫画爱好者打造无障碍的阅读平台，所有正版韩国漫画资源无需付费即可畅读。',
  },
  {
    question: '在韩漫网阅读需要注册账号吗？',
    answer: '不需要注册即可在线阅读所有漫画。不过注册账号后可以享受收藏漫画、记录阅读进度、接收更新通知等更多个性化功能。',
  },
  {
    question: '韩漫网支持哪些设备阅读？',
    answer: '韩漫网全面支持PC端、平板电脑和手机端阅读，采用响应式设计，可根据设备屏幕自动适配最佳阅读体验。无论您使用什么设备，都能畅享漫画阅读。',
  },
  {
    question: '漫画多久更新一次？',
    answer: '热门连载漫画通常每周更新一话，更新时间集中在周三至周五。您可以关注"最近更新"栏目，随时了解最新上线的漫画章节。',
  },
  {
    question: '如何搜索我想看的漫画？',
    answer: '您可以通过首页顶部的搜索栏输入漫画名称或作者名进行搜索，也可以通过分类导航按类型浏览感兴趣的作品。',
  },
];